import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Row, Label } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import emailValidator from 'email-validator';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ActionList from "../components/ActionList";
import ConfirmModal from "../components/ConfirmModal";

import ServiceDocumentGrid from "../components/ServiceDocumentGrid";

import { useDispatch, useSelector } from "react-redux";
import * as clientDocumentRequestAction from "../actions/ClientDocumentRequestAction";
import * as loginActions from "../actions/LoginActions";

const ClientDocumentRequestEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id, linkId } = useParams();

    const dispatch = useDispatch();

    const user = useSelector((state) => state.login.user);
    const loadingLogin = useSelector((state) => state.login.loading);
    const loading = useSelector((state) => state.cdr.loadingFBO);
    const fbo = useSelector((state) => state.cdr.fbo);
    
    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [refreshAction, setRefreshAction] = React.useState(false);

    const [projectCityValid, setProjectCityValid] = React.useState(true);
    const [selectedProjectCity, setSelectedProjectCity] = React.useState([]);
    const [cityList, setCityList] = React.useState([
        "Riyadh",
        "Jeddah",
        "Mecca",
        "Medina",
        "Dammam",
        "Khobar",
        "Dhahran",
        "Jubail",
        "Yanbu",
        "Taif",
        "Abha",
        "Khamis Mushait",
        "Hofuf",
        "Mubarraz",
        "Buraidah",
        "Unaizah",
        "Najran",
        "Hail",
        "Tabuk",
        "Al Baha",
        "Sakaka",
        "Arar",
        "Qatif",
        "Ras Tanura",
        "Khafji",
        "Al Zulfi",
        "Al Majmaah",
        "Al Dawadmi",
        "Al Kharj",
        "Wadi ad-Dawasir",
        "Sharurah",
        "Baljurashi",
        "Al Lith",
        "Rabigh",
        "Al Wajh",
        "Umluj",
        "Turaif",
        "Al Qurayyat",
        "Duba",
        "Abqaiq",
        "Hotat Bani Tamim",
        "Al Ula",
        "Al Bad",
        "Al Bukayriyah",
        "Al Jumum",
        "Thuwal",
        "Ahad Rafidah",
        "Tanomah",
        "Mahd adh Dhahab",
        "Al Ghat",
        "Al Hanakiyah",
        "Al Aqiq"
    ]);


    const [selectedStatus, setSelectedStatus] = React.useState("");
    const [showSubmitModal, setShowSubmitModal] = React.useState(false);
    const [showClientRespondedModal, setShowClientRespondedModal] = React.useState(false);
    const [showClosedModal, setShowClosedModal] = React.useState(false);
    const [showAbortedModal, setShowAbortedModal] = React.useState(false);
    
    React.useEffect(() => {
        async function fetchData() {
            if(user) {
	            dispatch(clientDocumentRequestAction.loadClientDocumentRequest(id, linkId, navigate));
            }
            else {
                await dispatch(loginActions.loadLogin("external@tuv.com", "admin", "123"));
                await dispatch(clientDocumentRequestAction.loadClientDocumentRequest(id, linkId, navigate));
            }
        }
        fetchData();
    }, [id, linkId]);

 
    React.useEffect(() => {
		setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        setSelectedProjectCity([]);
        
        if(fbo){
            reset(fbo.clientDocumentRequest);

            if(fbo.clientDocumentRequest.projectCity != null) {
                setSelectedProjectCity([fbo.clientDocumentRequest.projectCity]);
            }
        }

        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onClientDocumentRequestChange = (name, value) => {
        var copy_fboState = createDeepClone(fboState);

        if(value) {
            if(name === "policyNumber" || name === "referenceNumber" || name === "surveyResolutionNumber" || name === "baladyPolicy") {
                value = value.replace(/[^0-9]/g, "");
            }
            
            copy_fboState.clientDocumentRequest[name] = value;

            
        }
        else if(value === false) {
            copy_fboState.clientDocumentRequest[name] = false;
        }
        else {
            copy_fboState.clientDocumentRequest[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onProjectCityChange = (items) => {
        var selectedOptions = [];

        items.forEach(element => {
            if(element.label) {
                selectedOptions.push(element.label);
            }
            else {
                selectedOptions.push(element);
            }
        });
        
        setSelectedProjectCity(selectedOptions);

        if(selectedOptions.length > 0) {
            setProjectCityValid(true);
            onClientDocumentRequestChange("projectCity", selectedOptions.join(","))
        }
        else {
            onClientDocumentRequestChange("projectCity", null);
        }
    }

    const validateClientDocumentRequest = async(returnToUser) => {
        var valid = await trigger();
        
        if(valid) {
            if(returnToUser) {
                if(fboState.clientDocumentRequest.projectCity) {
                    return true;
                }
                else {
                    setProjectCityValid(false);
                    return false;
                }
            }
            else {
                return true;
            }
        }

        return false;
    }

    const onSaveClientDocumentRequest = async() => {
        var valid = await validateClientDocumentRequest(false);
        
        if(valid) {
            dispatch(clientDocumentRequestAction.saveClientDocumentRequest(fboState, selectedStatus, "", navigate));
        }

        onCloseModalClick();
    }

    const onCancelChanges = () => {
        setFBOState(fbo);

        if(fbo.clientDocumentRequest.projectCity != null) {
            setSelectedProjectCity([fbo.clientDocumentRequest.projectCity]);
        }
        else {
            setSelectedProjectCity([]);
        }

        setIsDirty(false);
        clearErrors();
    }

    const onSubmitClientDocumentRequestClick = async () => {
        var valid = await validateClientDocumentRequest(false);
        
        if(valid) {
            setSelectedStatus("Submitted");
            setShowSubmitModal(true);
        }
    }

    const onClientRespondedClientDocumentRequestClick = async () => {
        var valid = await validateClientDocumentRequest(true);

        if(valid) {
            setSelectedStatus("Client Responded");
            setShowClientRespondedModal(true);
        }
    }

    const onClosedClientDocumentRequestClick = () => {
        setSelectedStatus("Closed");
        setShowClosedModal(true);
    }

    const onAbortedClientDocumentRequestClick = () => {
        setSelectedStatus("Aborted");
        setShowAbortedModal(true);
    }

    const onCloseModalClick = () => {
        setSelectedStatus("");
        setShowSubmitModal(false);
        setShowClientRespondedModal(false);
        setShowClosedModal(false);
        setShowAbortedModal(false);
    }
    
    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    {user && user.isExternalUser === false &&
                        <BreadCrumb title={fboState && fboState.clientDocumentRequest.id > 0 ? "Edit Client Document Ticket" : "Add Client Document Ticket"} />
                    }
                    <Row>
                        <Col lg={user && user.isExternalUser === false && fboState && fboState.clientDocumentRequest.id > 0 ? 9 : 12}>
                            <CardLoader loading={loading || loadingLogin} />

                            <Card className="mb-3">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">{user && user.isExternalUser ? "Please Provide the following Information" : "Client Document Ticket"}</h5>
                                    <div className="flex-shrink-0">
                                        <div className="d-flex flex-wrap gap-2">
                                            {fboState && fboState.canSave &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLogin || !isDirty}
                                                onClick={onSaveClientDocumentRequest}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Save Ticket
                                            </button>
                                            }
                                            {fboState && fboState.canSave &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || loadingLogin || !isDirty}
                                                onClick={onCancelChanges}
                                            >
                                                <i className="ri-close-line label-icon align-middle"></i> Cancel
                                            </button>
                                            }
                                            {fboState && fboState.canSubmit &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLogin}
                                                onClick={onSubmitClientDocumentRequestClick}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Submit to Client
                                            </button>
                                            }
                                            {fboState && fboState.canResend &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLogin}
                                                onClick={onSubmitClientDocumentRequestClick}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Re-Submit to Client
                                            </button>
                                            }
                                            {fboState && fboState.canClientResponded &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLogin}
                                                onClick={onClientRespondedClientDocumentRequestClick}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Submit Information
                                            </button>
                                            }
                                            {fboState && fboState.canClosed &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLogin}
                                                onClick={onClosedClientDocumentRequestClick}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Close
                                            </button>
                                            }
                                            {fboState && fboState.canAborted &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLogin}
                                                onClick={onAbortedClientDocumentRequestClick}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Abort
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        {fboState && fboState.canViewBasicInfo &&
                                        <Fragment>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Ticket #</Label>
                                                <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                    value={(fboState && fboState.clientDocumentRequest.requestNumber) || ""}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Status</Label>
                                                <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                    value={(fboState && fboState.clientDocumentRequest.status) || ""}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">LOT Ref<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.lotRef ? "is-invalid" : ""}`} readOnly={!(fboState && fboState.canEditBasicInfo)}
                                                    title={errors.lotRef?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.lotRef) || ""}
                                                    {...register("lotRef", { required: "LOT Ref is required" })}
                                                    onChange={e => onClientDocumentRequestChange("lotRef", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Customer Name<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.customerName ? "is-invalid" : ""}`} readOnly={!(fboState && fboState.canEditBasicInfo)}
                                                    title={errors.customerName?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.customerName) || ""}
                                                    {...register("customerName", { required: "Customer Name is required" })}
                                                    onChange={e => onClientDocumentRequestChange("customerName", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Customer Email<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.customerEmail ? "is-invalid" : ""}`} readOnly={!(fboState && fboState.canEditBasicInfo)}
                                                    title={errors.customerEmail?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.customerEmail) || ""}
                                                    {...register("customerEmail", { required: "Customer Email is required", validate: (value) => emailValidator.validate(value) || 'Invalid email format' })}
                                                    onChange={e => onClientDocumentRequestChange("customerEmail", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Customer Mobile Number</Label>
                                                <input type="text" maxLength={256} className="form-control" readOnly={!(fboState && fboState.canEditBasicInfo)}
                                                    value={(fboState && fboState.clientDocumentRequest.customerMobileNumber) || ""}
                                                    onChange={e => onClientDocumentRequestChange("customerMobileNumber", e.target.value)}
                                                />
                                            </Col>
                                            {fboState && fbo.clientDocumentRequest && fbo.clientDocumentRequest.linkUrl &&
                                            <Col xxl={12} md={12}>
                                                <Label className="form-label">Customer Link</Label>
                                                <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                    value={(fboState && fboState.clientDocumentRequest.linkUrl) || ""}
                                                />
                                            </Col>
                                            }
                                            <div className="clearDiv"></div>
                                        </Fragment>
                                        }
                                        {fboState && fboState.canViewExtraInfo &&
                                        <Fragment>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Policy Number - رقم البوليصة<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.policyNumber ? "is-invalid" : ""}`}
                                                    readOnly={!(fboState && fboState.canEditExtraInfo)}
                                                    title={errors.policyNumber?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.policyNumber) || ""}
                                                    {...register("policyNumber", { required: "Policy Number - رقم البوليصة is required" })}
                                                    onChange={e => onClientDocumentRequestChange("policyNumber", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Reference Number - رقم المرجعي<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.referenceNumber ? "is-invalid" : ""}`}
                                                    readOnly={!(fboState && fboState.canEditExtraInfo)}
                                                    title={errors.referenceNumber?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.referenceNumber) || ""}
                                                    {...register("referenceNumber", { required: "Reference Number - رقم المرجعي is required" })}
                                                    onChange={e => onClientDocumentRequestChange("referenceNumber", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Survey Resolution Number - رقم القرار المساحي<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.surveyResolutionNumber ? "is-invalid" : ""}`}
                                                    readOnly={!(fboState && fboState.canEditExtraInfo)}
                                                    title={errors.surveyResolutionNumber?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.surveyResolutionNumber) || ""}
                                                    {...register("surveyResolutionNumber", { required: "Survey Resolution Number - رقم القرار المساحي is required" })}
                                                    onChange={e => onClientDocumentRequestChange("surveyResolutionNumber", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Balady Policy - الرقم المرجعي في بلدي</Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.baladyPolicy ? "is-invalid" : ""}`}
                                                    readOnly={!(fboState && fboState.canEditExtraInfo)}
                                                    title={errors.baladyPolicy?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.baladyPolicy) || ""}
                                                    {...register("baladyPolicy", { required: false })}
                                                    onChange={e => onClientDocumentRequestChange("baladyPolicy", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Mobile Number - رقم الجوال<span className="required">*</span></Label>
                                                <input type="text" maxLength={256} className={`form-control ${errors.mobileNumber ? "is-invalid" : ""}`}
                                                    readOnly={!(fboState && fboState.canEditExtraInfo)}
                                                    title={errors.mobileNumber?.message}
                                                    value={(fboState && fboState.clientDocumentRequest.mobileNumber) || ""}
                                                    {...register("mobileNumber", { required: "Mobile Number - رقم الجوال is required" })}
                                                    onChange={e => onClientDocumentRequestChange("mobileNumber", e.target.value)}
                                                />
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Project City - المدينة المشروع<span className="required">*</span></Label>
                                                <Typeahead
                                                    id="fldProjectCity" style={{border: (projectCityValid ? "" : "1px solid red")}}
                                                    allowNew={true}
                                                    newSelectionPrefix="Add a new city: "
                                                    disabled={fboState && fboState.canEditExtraInfo ? false : true}
                                                    options={cityList}
                                                    placeholder="Select Project City..."
                                                    selected = {selectedProjectCity}
                                                    onChange = {(item) => onProjectCityChange(item)}
                                                />
                                            </Col>
                                        </Fragment>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>

                            {fboState && fboState.clientDocumentRequest.id > 0 && fboState.canViewExtraInfo &&
                                <ServiceDocumentGrid 
                                    serviceId={-6}
                                    refId={fboState.clientDocumentRequest.id}
                                    refName={"CLIENT_DOCUMENT_REQUEST"}
                                    parentId={fboState.clientDocumentRequest.id}
                                    parentName={"CLIENT_DOCUMENT_REQUEST"}
                                    isProduct={false}
                                    collapsed={"false"}
                                    canAddDocument={fboState.canChangeDocument}
                                    canDeleteDocument={fboState.canChangeDocument}
                                    canAddCertificate={false}
                                    canDeleteCertificate={false}
                                    onChange={reloadAction}
                                />
                            }
                        </Col>

                        {user && user.isExternalUser === false && fboState && fboState.clientDocumentRequest.id > 0 &&
                        <Col lg={3}>
                            <ActionList id={fboState.clientDocumentRequest.id} name={"CLIENT_DOCUMENT_REQUEST"} refreshAction={refreshAction} />
                        </Col>
                        }
                    </Row>
                </Container>
                <ConfirmModal message={"Are you sure you want to \"Submit to Client\"?"} show={showSubmitModal} onCloseClick={onCloseModalClick} onYesClick={onSaveClientDocumentRequest} />
                <ConfirmModal message={"Are you sure you want to \"Submit Information\"?"} show={showClientRespondedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveClientDocumentRequest} />
                <ConfirmModal message={"Are you sure you want to \"Close\"?"} show={showClosedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveClientDocumentRequest} />
                <ConfirmModal message={"Are you sure you want to \"Abort\"?"} show={showAbortedModal} onCloseClick={onCloseModalClick} onYesClick={onSaveClientDocumentRequest} />
            </div>
        </Fragment>
    );
}

export default ClientDocumentRequestEditScreen;